import { API, retryRequest } from 'src/services'
import { freezeItems } from './freezeItems'

const extrairItens = (body) => {
  if (Array.isArray(body?.success)) return body.success
  if (Array.isArray(body?.resultado)) return body.resultado
  if (Array.isArray(body)) return body
  return []
}

const normalizarRegraDeCalculo = (regraDeCalculo) => {
  if (!regraDeCalculo) return null

  return {
    ...regraDeCalculo,
    name: regraDeCalculo.name || regraDeCalculo.nome
  }
}

const normalizarSobreaviso = (sobreaviso) => ({
  ...sobreaviso,
  name: sobreaviso.name || sobreaviso.nome,
  code: sobreaviso.code || sobreaviso.codigo,
  startTime: sobreaviso.startTime || sobreaviso.inicio,
  endTime: sobreaviso.endTime || sobreaviso.fim,
  customRules: sobreaviso.customRules || normalizarRegraDeCalculo(sobreaviso.regraDeCalculo)
})

export default {
  namespaced: true,
  state: {
    items: [],
    loading: false
  },
  getters: {
  },
  mutations: {
    saveItems (state, payload) {
      state.items = freezeItems(extrairItens(payload).map(normalizarSobreaviso))
      state.loading = false
    },
    loading (state, payload) {
      state.loading = Boolean(payload)
    }
  },
  actions: {
    async fetchItems ({ commit }) {
      commit('loading', true)

      const result = await retryRequest(API.sobreavisos.get)
      commit('saveItems', result.body)
    }
  }
}
